import { Component, computed, EventEmitter, HostListener, Input, OnInit, Output, signal, SimpleChanges, ViewChild } from '@angular/core';
import * as $ from 'jquery';
import pq from 'pqgrid';
import { DeleteComponent } from '../delete-confirm/delete-confirm.component';
import { AlertParameters } from '../models/AlertParameters';
import { DeleteParameters } from '../models/DeleteParameters';
import { DispatchItem } from '../models/DispatchItem';
import { DispatchParameters } from '../models/DispatchParameters';
import { EmailQuestionFormParameters } from '../models/EmailQuestionFormParameters';
import { LoadBankType, LocationType } from '../models/Enums';
import { ListItem } from '../models/ListItem';
import { Load } from '../models/Load';
import { LoadBankApplyParameters } from '../models/LoadBankApplyParameters';
import { LocationConfirmInfo } from '../models/LocationConfirmInfo';
import { MoveSplitDispatchParameters } from '../models/MoveSplitDispatchParameters';
import { RoundCompleteEvent } from '../models/RoundCompleteEvent';
import { RoundParameters } from '../models/RoundParameters';
import { ScheduleDefaults } from '../models/ScheduleDefaults';
import { ScheduleItem } from '../models/ScheduleItem';
import { ScheduleLoads } from '../models/ScheduleLoads';
import { ScheduleParameters } from '../models/ScheduleParameters';
import { PqgridComponent } from '../pqgrid/pqgrid.component';
import { ScheduleDataService } from '../services/schedule-data.service';
import { ToastNotificationComponent } from '../toast-notification/toast-notification.component';
import { SchedulesInfo } from '../models/SchedulesInfo';
import { ScheduleRequest } from '../models/ScheduleRequest';
import { CopyDispatchParameters } from '../models/CopyDispatchParameters';
import { UserDataService } from '../services/user-data.service';
import { UserDefaultParameters } from '../models/UserDefaultParameters';
import { UserSettingsService } from '../services/user-settings.service';
import { ListDataService } from '../services/list-data.service';
import { EquipmentListItem } from '../models/EquipmentListItem';

@Component({
    selector: 'schedules',
    templateUrl: 'schedules.component.html',
    styles: [],
    standalone: false
})
export class SchedulesComponent implements OnInit {

    constructor(private _scheduleDataService: ScheduleDataService, private _userDataService: UserDataService, private _userSettingsService: UserSettingsService, private _listDataService: ListDataService) { }

    @ViewChild('scheduleGrid') scheduleGrid: PqgridComponent;
    @ViewChild('toastNotification') toastNotification: ToastNotificationComponent;
    @ViewChild('deleteComponent') deleteComponent!: DeleteComponent;

    @Input() planningParameters: ScheduleParameters = new ScheduleParameters();
    @Input() refreshData: boolean;
    @Input() refreshGrid: boolean;
    scheduleParameters: ScheduleParameters = new ScheduleParameters();
    deleteConfirmFormId: string = 'scheduleDispatchDeleteModal';
    @Output() refreshDataComplete: EventEmitter<boolean> = new EventEmitter<boolean>();
    dispatchFormId: string = 'dispatchModal';
    copyDispatchModalId: string = 'copyDispatchModal';
    confirmTruckersFormId: string = 'confirmTruckerModal';
    loadsStatusModalId: string = 'loadsStatusModalId';
    scheduleForm: ScheduleDefaults = new ScheduleDefaults()
    dispatchForm: DispatchParameters = new DispatchParameters();
    copyDispatchParameters: CopyDispatchParameters = new CopyDispatchParameters();
    moveSplitDispatchFormParams: MoveSplitDispatchParameters = new MoveSplitDispatchParameters();
    moveSplitFormId: string = 'moveSplitModal';
    sendDispatchId: number = 0;
    sendDispatchRefresh: boolean = false;
    loadsStatusDispatchId: number = 0;
    loadsStatusRefresh: boolean = false;
    textsStatusDispatchId: number = 0;
    textsStatusRefresh: boolean = false;
    errorMessage: string = '';
    truckerList: ListItem[] = [];
    locationList: ListItem[] = [];
    locationCityList: ListItem[] = [];
    scheduleDaysList: ListItem[] = [];
    dispatchTypeLabel: string = 'Origin';
    isDeleteConfirmed: boolean = false;
    showLoadsByDay: boolean = false;
    savingDefaultFilters: boolean = false;

    emailQuestionForm: EmailQuestionFormParameters = new EmailQuestionFormParameters();
    emailQuestionFormId: string = 'emailQuestionModal'
    deleteItemParams: DeleteParameters = new DeleteParameters();

    loadBankApplyFormId: string = 'loadBankApplyModal';
    loadBankApplyParameters: LoadBankApplyParameters = new LoadBankApplyParameters();

    roundFormId: string = 'roundModal';
    copyRoundFormId: string = 'copyRoundModal';
    roundParameters: RoundParameters = new RoundParameters();

    alertTruckerForm: AlertParameters = new AlertParameters();
    alertTruckerFormId: string = 'alertTruckerModal';

    locationConfirmInfo: LocationConfirmInfo = new LocationConfirmInfo();
    useDefaultFilters: boolean = false;
    equipmentTypes: EquipmentListItem[] = [];
    equipmentTypeOptions: string[] = [''];
    showEquipmentFields: boolean = false;

    visibleSchedules = signal<ScheduleItem[]>([]);
    totals = computed(() => {
        const schedules = this.visibleSchedules();
        return {
            loads: schedules.reduce((sum, s) => sum + (Number(s.loads) || 0), 0),
            dispatched: schedules.reduce((sum, s) => sum + (Number(s.dispatchedLoads) || 0), 0),
            balance: schedules.reduce((sum, s) => sum + (Number(s.balanceLoads) || 0), 0),
            unassigned: schedules.reduce((sum, s) => sum + (Number(s.unassignedLoads) || 0), 0),
            unconfirmed: schedules.reduce((sum, s) => sum + (Number(s.unconfirmedLoads) || 0), 0),
            confirmed: schedules.reduce((sum, s) => sum + (Number(s.confirmedLoads) || 0), 0)
        };
    });

    hoursOptions = [
        "", "12:00 AM", "12:30 AM", "01:00 AM", "01:30 AM", "02:00 AM", "02:30 AM", "03:00 AM", "03:30 AM", "04:00 AM", "04:30 AM", "05:00 AM", "05:30 AM", "06:00 AM", "06:30 AM", "07:00 AM", "07:30 AM", "08:00 AM", "08:30 AM",
        "09:00 AM", "09:30 AM", "10:00 AM", "10:30 AM", "11:00 AM", "11:30 AM", "12:00 PM", "12:30 PM", "01:00 PM", "01:30 PM", "02:00 PM", "02:30 PM", "03:00 PM", "03:30 PM", "04:00 PM", "04:30 PM", "05:00 PM", "05:30 PM",
        "06:00 PM", "06:30 PM", "07:00 PM", "07:30 PM", "08:00 PM", "08:30 PM", "09:00 PM", "09:30 PM", "10:00 PM", "10:30 PM", "11:00 PM", "11:30 PM"
    ];

    deliveryTimeEditor = {
        type: "select",
        options: this.hoursOptions,
        mapIndices: { id: "deliveryTime", value: "deliveryTime" }
    };

    scheduleColumnsWithDays = [];
    scheduleColumns = [
        {
            title: "", minWidth: 30, maxWidth: 30, type: "detail", resizable: false, editable: false, sortable: false, nodrag: true,
            render: function (ui) {
                if (ui.rowData.dispatches.length == 0) {
                    return ""; //no icon.
                }
                else {
                    return null;
                }
            }
        },
        {
            title: "", width: 95, dataType: "html", resizable: false, editable: false, sortable: false, nodrag: true,
            render: function (ui) {
                return '<a href="#" class="grid-icon-btn edit-btn" data-bs-toggle="modal" data-bs-target="#scheduleModal" title="edit schedule"><i class="fa-solid fa-pen-to-square fa-lg"></i></a>' +
                    '<a href="#" class="grid-icon-btn delete-btn" data-bs-toggle="modal" data-bs-target="#scheduleDispatchDeleteModal" title="delete schedule"><i class="fa-solid fa-trash-can fa-lg"></i></a>' +
                    '<a href="#" class="grid-icon-btn dispatch-btn" data-bs-toggle="modal" data-bs-target="#dispatchModal" title="create new dispatch"><i class="fa-solid fa-truck fa-lg"></i></a>' +
                    '<a href="#" class="grid-icon-btn question-email-btn" data-bs-toggle="modal" data-bs-target="#emailQuestionModal" title="question-email schedule"><i class="fa-solid fa-question-circle fa-lg"></i></a>';
            }
        },
        { title: "Loc", width: 70, dataType: "string", dataIndx: "locCode", editable: false, hidden: true, filter: { crules: [{ condition: "begin" }] } },
        { title: "Customer", width: 250, dataType: "string", dataIndx: "customerName", editable: false, filter: { crules: [{ condition: "contain" }] } },
        { title: "Destination", width: 300, dataType: "string", dataIndx: "locationName", editable: false, filter: { crules: [{ condition: "contain" }] } },
        { title: "Date Range", width: 150, dataType: "string", dataIndx: "dateRange", editable: false, filter: { crules: [{ condition: "contain" }] } },
        { title: "City", width: 150, dataType: "string", dataIndx: "locationCity", editable: false, filter: { crules: [{ condition: "contain" }] } },
        { title: "ST", width: 70, dataType: "string", dataIndx: "locationState", editable: false, filter: { crules: [{ condition: "range" }] } },
        { title: "Comm", width: 100, dataType: "string", dataIndx: "commodityCode", editable: false, filter: { crules: [{ condition: "range" }] } },
        { title: "F/D", width: 90, dataType: "string", dataIndx: "deliveryTerm", editable: false, filter: { crules: [{ condition: "range" }] } },
        { title: "Loads", width: 70, dataType: "integer", dataIndx: "loads", editable: true, render: function (ui) { return { cls: 'grid-col-editable' }; } },
        { title: "Disp", width: 90, dataType: "integer", dataIndx: "dispatchedLoads", editable: false },
        {
            title: "Executed", width: 110, dataType: "html", dataIndx: "executed", editable: false, sortable: false, align: 'center',
            render: function (ui) {
                var executed = 0;
                var total = 0;
                if (ui.rowData.dispatches) {
                    ui.rowData.dispatches.forEach(function(dispatch: any) {
                        if (dispatch.loadList) {
                            dispatch.loadList.forEach(function(load: any) {
                                total++;
                                if (load.preAdvise || load.delivered) {
                                    executed++;
                                }
                            });
                        }
                    });
                }
                var percentage = total > 0 ? Math.round((executed / total) * 100) : 0;
                var barColor = percentage === 100 ? '#198754' : (percentage > 0 ? '#ffc107' : '#6c757d');
                var textColor = percentage === 100 ? '#fff' : '#333';
                var textShadow = percentage === 100 ? '0 0 3px rgba(0,0,0,0.3)' : '0 0 3px rgba(255,255,255,0.9)';

                return '<div style="position: relative; height: 18px; background-color: #e9ecef; border-radius: 4px; overflow: hidden;">' +
                    '<div style="position: absolute; top: 0; left: 0; width: ' + percentage + '%; height: 100%; background-color: ' + barColor + '; transition: width 0.3s ease;"></div>' +
                    '<span style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); font-size: 11px; font-weight: 600; color: ' + textColor + '; text-shadow: ' + textShadow + '; z-index: 1;">' + executed + '/' + total + '</span>' +
                    '</div>';
            }
        },
        { title: "Bal", width: 90, dataType: "integer", dataIndx: "balanceLoads", editable: false },
        { title: "Un-Assign", width: 90, dataType: "integer", dataIndx: "unassignedLoads", editable: false },
        { title: "Un-Conf", width: 90, dataType: "integer", dataIndx: "unconfirmedLoads", editable: false },
        { title: "Conf", width: 90, dataType: "integer", dataIndx: "confirmedLoads", editable: false },
        { title: "Entered By", width: 150, dataType: "string", dataIndx: "enteredBy", editable: false, filter: { crules: [{ condition: "contain" }] } },
        { title: "Cust Code", width: 120, dataType: "string", dataIndx: "customerCode", editable: false, filter: { crules: [{ condition: "begin" }] } },
        { title: "Dest Code", width: 120, dataType: "string", dataIndx: "locationCode", editable: false, filter: { crules: [{ condition: "begin" }] } },
        { title: "Schedule ID", width: 100, dataType: "string", dataIndx: "scheduleIdDisplay", editable: false, filter: { crules: [{ condition: "contain" }] } }
    ];

    dispatchColumns = [
        {
            title: "", minWidth: 30, maxWidth: 30, type: "detail", resizable: false, editable: false, sortable: false, nodrag: true,
            render: function (ui) {
                if (ui.rowData.loadList.length == 0) {
                    return ""; //no icon.
                }
                else {
                    return null;
                }
            }
        },
        {
            title: "", width: 232, dataType: "html", resizable: false, editable: false, sortable: false, nodrag: true,
            style: { 'overflow': 'visible' },
            render: function (ui) {
                var returnItem = '<a href="#" class="grid-icon-btn edit-btn" data-bs-toggle="modal" data-bs-target="#dispatchModal" title="edit dispatch"><i class="fa-solid fa-pen-to-square fa-lg"></i></a>' +
                    '<a href="#" class="grid-icon-btn copy-btn" data-bs-toggle="modal" data-bs-target="#copyDispatchModal" title="copy dispatch"><i class="fa-solid fa-copy fa-lg"></i></a>' +
                    '<a href="#" class="grid-icon-btn delete-btn" data-bs-toggle="modal" data-bs-target="#scheduleDispatchDeleteModal" title="delete dispatch"><i class="fa-solid fa-trash-can fa-lg"></i></a>' +
                    '<a href="#" class="grid-icon-btn move-split-btn" data-bs-toggle="modal" data-bs-target="#moveSplitModal" title="move-split dispatch"><i class="fa-solid fa-pie-chart fa-lg"></i></a>' +
                    '<a href="#" class="grid-icon-btn alert-trucker-btn" data-bs-toggle="modal" data-bs-target="#alertTruckerModal" title="alert truckers"><i class="fa-solid fa-bell fa-lg"></i></a>' +
                    '<a href="#" class="grid-icon-btn question-email-btn" data-bs-toggle="modal" data-bs-target="#emailQuestionModal" title="question-email dispatch"><i class="fa-solid fa-question-circle fa-lg"></i></a>' +
                    '<a href="#" class="grid-icon-btn send-btn" data-bs-toggle="modal" data-bs-target="#confirmDispatchModal" title="send dispatch"><i class="fa-solid fa-envelope fa-lg"></i></a>';

                if (ui.rowData.hasTextMessage) {
                    returnItem += '<a href="#" class="grid-icon-btn text-btn" data-bs-toggle="modal" data-bs-target="#textsStatusModal" title="texts status"><i class="fa-solid fa-message fa-lg"></i></a>';
                }

                returnItem += '<a href="#" class="grid-icon-btn roger-btn" data-bs-toggle="modal" data-bs-target="#loadsStatusModal" title="Roger loads status"><i class="fa-regular fa-registered fa-lg"></i></a>' +
                    '<a href="#" class="grid-icon-btn round-btn" data-bs-toggle="modal" data-bs-target="#roundModal" title="round"><i class="fa-solid fa-circle-nodes fa-lg"></i></a>';

                if (ui.rowData.roundId > 0) {
                    returnItem += '<a href="#" class="grid-icon-btn copy-round-btn" data-bs-toggle="modal" data-bs-target="#copyRoundModal" title="copy round"><i class="fa-solid fa-object-ungroup fa-lg"></i></a>';
                }

                return returnItem;

            }
        },
        {
            title: "Trucker", width: 250, dataType: "string", dataIndx: "truckerName", editable: false,
            render: function render(ui) {
                if (ui.rowData.roundId > 0) {
                    return { cls: 'text-danger' };
                }
                else {
                    return null;
                }
            },
            filter: { crules: [{ condition: "contain" }] }

        },
        { title: "Customer", width: 250, dataType: "string", dataIndx: "customerName", editable: false, filter: { crules: [{ condition: "contain" }] } },
        { title: "Origin", width: 300, dataType: "string", dataIndx: "locationName", editable: false, filter: { crules: [{ condition: "contain" }] } },
        { title: "City", width: 150, dataType: "string", dataIndx: "locationCity", editable: false, filter: { crules: [{ condition: "contain" }] } },
        { title: "ST", width: 70, dataType: "string", dataIndx: "locationState", editable: false, filter: { crules: [{ condition: "range" }] } },
        { title: "Loads", width: 90, dataType: "integer", dataIndx: "loads", editable: false },
        {
            title: "Executed", width: 110, dataType: "html", dataIndx: "executed", editable: false, sortable: false, align: 'center',
            render: function (ui) {
                var executed = 0;
                var total = 0;
                if (ui.rowData.loadList) {
                    ui.rowData.loadList.forEach(function(load: any) {
                        total++;
                        if (load.preAdvise || load.delivered) {
                            executed++;
                        }
                    });
                }
                var percentage = total > 0 ? Math.round((executed / total) * 100) : 0;
                var barColor = percentage === 100 ? '#198754' : (percentage > 0 ? '#ffc107' : '#6c757d');
                var textColor = percentage === 100 ? '#fff' : '#333';
                var textShadow = percentage === 100 ? '0 0 3px rgba(0,0,0,0.3)' : '0 0 3px rgba(255,255,255,0.9)';

                return '<div style="position: relative; height: 18px; background-color: #e9ecef; border-radius: 4px; overflow: hidden;">' +
                    '<div style="position: absolute; top: 0; left: 0; width: ' + percentage + '%; height: 100%; background-color: ' + barColor + '; transition: width 0.3s ease;"></div>' +
                    '<span style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); font-size: 11px; font-weight: 600; color: ' + textColor + '; text-shadow: ' + textShadow + '; z-index: 1;">' + executed + '/' + total + '</span>' +
                    '</div>';
            }
        },
        { title: "Rate", width: 120, dataType: "string", dataIndx: "rate", editable: false },
        { title: "Unload #", width: 120, dataType: "string", dataIndx: "unloadNumber", editable: false },
        { title: "Load #", width: 120, dataType: "string", dataIndx: "loadNumber", editable: false },
        { title: "Internal Notes", width: 200, dataType: "string", dataIndx: "internalNotes", editable: false },
        { title: "Email Status", width: 120, dataType: "string", dataIndx: "emailStatus", editable: false },
        { title: "Roger Status", width: 120, dataType: "string", dataIndx: "rogerStatus", editable: false },
        {
            title: "Round", width: 120, dataType: "string", dataIndx: "round", editable: false,
            render: function render(ui) {
                return { cls: 'text-danger' };
            },
            filter: { crules: [{ condition: "equal" }] }
        },
        { title: "Entered By", width: 150, dataType: "string", dataIndx: "enteredBy", editable: false, filter: { crules: [{ condition: "begin" }] } },
        { title: "Trucker ID", width: 120, dataType: "string", dataIndx: "truckerCode", editable: false, filter: { crules: [{ condition: "begin" }] } },
        { title: "Dispatch ID", width: 120, dataType: "string", dataIndx: "dispatchIdDisplay", editable: false, filter: { crules: [{ condition: "begin" }] } },
    ];

    loadColumns = [
        {
            title: "<input type='checkbox' style='margin-left: 10px;'/>",
            cb: {
                all: true,
                header: true
            },
            width: 30, type: "checkbox", dataIndx: "selected", resizable: false, editable: true, align: 'center',
            sortable: false, nodrag: true, dataType: "bool", editor: false
        },
        {
            title: "", width: 75, dataType: "html", resizable: false, editable: false, sortable: false, nodrag: true,
            render: function (ui) {
                return '<a href="#" class="grid-icon-btn delete-btn" data-bs-toggle="modal" data-bs-target="#scheduleDispatchDeleteModal" title="delete load"><i class="fa-solid fa-trash-can fa-lg"></i></a>' +
                    '<a href="#" class="grid-icon-btn load-btn" title="apply load number" data-bs-toggle="modal" data-bs-target="#loadBankApplyModal"><i class="fa-solid fa-upload fa-lg"></i></a>' +
                    '<a href="#" class="grid-icon-btn unload-btn" title="apply unload number" data-bs-toggle="modal" data-bs-target="#loadBankApplyModal"><i class="fa-solid fa-download fa-lg"></i></a>';
            }
        },
        {
            title: "Load Date", width: 100, dataType: "date", dataIndx: "pickupDate", editable: true,
            format: 'm/d/yy',
            cls: 'pq-calendar pq-side-icon',
            editor: {
                type: 'textbox',
                init: this.dateEditor,
                getData: function (ui) {
                    //convert from column format to native js date format "mm/dd/yy"
                    var dt = $.datepicker.parseDate(ui.column.format, ui.$cell.find("input").val());
                    return $.datepicker.formatDate("mm/dd/yy", dt);//don't change it.
                }
            },
        },
        { title: "Day", width: 70, dataType: "string", dataIndx: "dayOfWeek", editable: false },
        { title: "Load #", width: 120, dataType: "string", dataIndx: "loadNumber", editable: true },
        { title: "Notes", width: 200, dataType: "string", dataIndx: "notes", editable: true },
        {
            title: "Delivery Date", width: 120, dataType: "string", dataIndx: "deliveryDate", editable: true,
            format: 'm/d/yy',
            cls: 'pq-calendar pq-side-icon',
            editor: {
                type: 'textbox',
                init: this.dateEditor,
                getData: function (ui) {
                    //convert from column format to native js date format "mm/dd/yy"
                    var dt = $.datepicker.parseDate(ui.column.format, ui.$cell.find("input").val());
                    return $.datepicker.formatDate("mm/dd/yy", dt);//don't change it.
                }
            },
        },
        { title: "Delivery Time", width: 120, dataType: "string", dataIndx: "deliveryTime", editable: true, editor: this.deliveryTimeEditor },
        { title: "PA", width: 60, type: "checkbox", dataType: "bool", dataIndx: "preAdvise", resizable: false, editable: true, align: 'center', editor: false },
        { title: "Dlvd", width: 70, type: "checkbox", dataType: "bool", dataIndx: "delivered", resizable: false, editable: true, align: 'center', editor: false },
        { title: "Ticket #", width: 120, dataType: "string", dataIndx: "ticket", editable: true },
        {
            title: "Delivered Date", width: 130, dataType: "string", dataIndx: "deliveredDate", editable: true,
            format: 'm/d/yy',
            cls: 'pq-calendar pq-side-icon',
            editor: {
                type: 'textbox',
                init: this.dateEditor,
                getData: function (ui) {
                    //convert from column format to native js date format "mm/dd/yy"
                    var dt = $.datepicker.parseDate(ui.column.format, ui.$cell.find("input").val());
                    return $.datepicker.formatDate("mm/dd/yy", dt);//don't change it.
                }
            },
        },
        { title: "FS", width: 60, type: "checkbox", dataType: "bool", dataIndx: "finalSettled", resizable: false, editable: true, align: 'center', editor: false },
        { title: "Unload #", width: 120, dataType: "string", dataIndx: "unloadNumber", editable: true },
        {
            title: "Equip Type", width: 200, dataType: "string", dataIndx: "equipmentType", editable: true,
            editor: {
                type: "select",
                options: this.equipmentTypeOptions,
                mapIndices: { id: "equipmentType", value: "equipmentType" }
            }
        },
        { title: "Weight", width: 100, dataType: "string", dataIndx: "equipmentWeight", editable: true },
        { title: "Weight UOM", width: 100, dataType: "string", dataIndx: "equipmentWeightUOM", editable: false },
        { title: "Driver Name", width: 130, dataType: "string", dataIndx: "driverName", editable: true, editor: {
                type: 'textbox',
                init: (ui: any) => {
                    const $el = ui.$editor || ui.$cell.find('input');
                    $el.attr('maxlength', 50);
                    $el.on('paste', (e: any) => {
                        const pasted = (e.originalEvent?.clipboardData || (window as any).clipboardData)?.getData('text') || '';
                        const current = ($el.val() as string) || '';
                        if (current.length + pasted.length > 50) {
                            this.toastNotification.showToast("Driver Name was truncated to 50 characters.", 3000, "error");
                        }
                    });
                }
            }
        },
        { title: "License Plate", width: 130, dataType: "string", dataIndx: "licensePlateNumber", editable: true,
            editor: {
                type: 'textbox',
                init: (ui: any) => {
                    const $el = ui.$editor || ui.$cell.find('input');
                    $el.attr('maxlength', 50);
                    $el.on('paste', (e: any) => {
                        const pasted = (e.originalEvent?.clipboardData || (window as any).clipboardData)?.getData('text') || '';
                        const current = ($el.val() as string) || '';
                        if (current.length + pasted.length > 50) {
                            this.toastNotification.showToast("License Plate was truncated to 50 characters.", 3000, "error");
                        }
                    });
                }
            }
        },
        { title: "Email Status", width: 120, dataType: "string", dataIndx: "loadEmailStatus", editable: false },
        { title: "Roger Status", width: 120, dataType: "string", dataIndx: "loadRogerStatus", editable: false },
        { title: "Roger Load Status", width: 150, dataType: "string", dataIndx: "rogerLoadStatus", editable: false },
        { title: "Roger Trip Status", width: 150, dataType: "string", dataIndx: "rogerTripStatus", editable: false },
        { title: "CW Status", width: 120, dataType: "string", dataIndx: "loadCompuweighStatus", editable: false },
        { title: "Load ID", width: 100, dataType: "string", dataIndx: "loadIdDisplay", editable: false }
    ];

    loadNoEditColumns = [
        { title: "Load Date", width: 100, dataType: "date", dataIndx: "pickupDate", editable: false, format: 'm/d/yy' },
        { title: "Day", width: 70, dataType: "string", dataIndx: "dayOfWeek", editable: false },
        { title: "Load #", width: 120, dataType: "string", dataIndx: "loadNumber", editable: false },
        { title: "Notes", width: 200, dataType: "string", dataIndx: "notes", editable: false },
        { title: "Delivery Date", width: 120, dataType: "string", dataIndx: "deliveryDate", editable: false, format: 'm/d/yy' },
        { title: "Delivery Time", width: 120, dataType: "string", dataIndx: "deliveryTime", editable: false },
        { title: "PA", width: 60, type: "checkbox", dataType: "bool", dataIndx: "preAdvise", resizable: false, editable: true, align: 'center', editor: false },
        { title: "Dlvd", width: 70, type: "checkbox", dataType: "bool", dataIndx: "delivered", resizable: false, editable: true, align: 'center', editor: false },
        { title: "Ticket #", width: 120, dataType: "string", dataIndx: "ticket", editable: true },
        { title: "Delivered Date", width: 130, dataType: "string", dataIndx: "deliveredDate", editable: false, format: 'm/d/yy' },
        { title: "FS", width: 60, type: "checkbox", dataType: "bool", dataIndx: "finalSettled", resizable: false, editable: true, align: 'center', editor: false },
        { title: "Unload #", width: 120, dataType: "string", dataIndx: "unloadNumber", editable: false },
        {
            title: "Equip Type", width: 200, dataType: "string", dataIndx: "equipmentType", editable: true,
            editor: {
                type: "select",
                options: this.equipmentTypeOptions,
                mapIndices: { id: "equipmentType", value: "equipmentType" }
            }
        },
        { title: "Weight", width: 100, dataType: "string", dataIndx: "equipmentWeight", editable: true },
        { title: "Weight UOM", width: 100, dataType: "string", dataIndx: "equipmentWeightUOM", editable: false },
        { title: "Driver Name", width: 130, dataType: "string", dataIndx: "driverName", editable: true, editor: {
                type: 'textbox',
                init: (ui: any) => {
                    const $el = ui.$editor || ui.$cell.find('input');
                    $el.attr('maxlength', 50);
                    $el.on('paste', (e: any) => {
                        const pasted = (e.originalEvent?.clipboardData || (window as any).clipboardData)?.getData('text') || '';
                        const current = ($el.val() as string) || '';
                        if (current.length + pasted.length > 50) {
                            this.toastNotification.showToast("Driver Name was truncated to 50 characters.", 3000, "error");
                        }
                    });
                }
            }
        },
        { title: "License Plate", width: 130, dataType: "string", dataIndx: "licensePlateNumber", editable: true,
            editor: {
                type: 'textbox',
                init: (ui: any) => {
                    const $el = ui.$editor || ui.$cell.find('input');
                    $el.attr('maxlength', 50);
                    $el.on('paste', (e: any) => {
                        const pasted = (e.originalEvent?.clipboardData || (window as any).clipboardData)?.getData('text') || '';
                        const current = ($el.val() as string) || '';
                        if (current.length + pasted.length > 50) {
                            this.toastNotification.showToast("License Plate was truncated to 50 characters.", 3000, "error");
                        }
                    });
                }
            }
        },
        { title: "Email Status", width: 120, dataType: "string", dataIndx: "loadEmailStatus", editable: false },
        { title: "Roger Status", width: 120, dataType: "string", dataIndx: "loadRogerStatus", editable: false },
        { title: "Roger Load Status", width: 150, dataType: "string", dataIndx: "rogerLoadStatus", editable: false },
        { title: "Roger Trip Status", width: 150, dataType: "string", dataIndx: "rogerTripStatus", editable: false },
        { title: "CW Status", width: 120, dataType: "string", dataIndx: "loadCompuweighStatus", editable: false },
        { title: "Load ID", width: 100, dataType: "string", dataIndx: "loadIdDisplay", editable: false }
    ];


    dateEditor(ui) {
        var $inp = ui.$cell.find("input"),
            grid = this,
            format = ui.column.format || "mm/dd/yy",
            val: string = $inp.val(),
            val = val ? $.datepicker.formatDate(format, new Date(val)) : "";

        //initialize the editor
        $inp.val(val)
            .datepicker({
                changeMonth: true,
                changeYear: true,
                dateFormat: format,
                showAnim: '',
                onSelect: function () {
                    this.firstOpen = true;
                },
                beforeShow: function (input, inst) {
                    setTimeout(function () {
                        //to fix the issue of datepicker z-index when grid is in maximized state.
                        $('.ui-datepicker').css('z-index', 999999999999);
                    });
                    //return !this.firstOpen; uncomment if don't want to allow datepicker editor to open upon focus in editor after first opening.
                },
                onClose: function () {
                    this.focus();
                }
            });
    }

    scheduleOptions: pq.gridT.options = {
        showTop: false,
        reactive: true,
        locale: "en",
        height: "flex",
        fillHandle: "",
        freezeCols: 2,
        resizable: true,
        numberCell: { show: false },
        columnTemplate: { width: 100 },
        colModel: this.scheduleColumns,
        dataModel: {
            data: []
        },
        animModel: { on: false },
        detailModel: {
            header: true,
            init: (ui: any) => this.getDispatchGrid(ui.rowData.dispatches)
        },
        filterModel: {
            header: true,
            menuIcon: false,
            on: true
        },
        filter: () => this.onGridFilter(),
        sortModel: {
            cancel: true,
            type: "local",
            single: false,
            space: true
        },
        beforePaste: function (event) {
            event.preventDefault();
        },
        postRenderInterval: -1
    };

    saveDefaultFilters(): void {
        this.savingDefaultFilters = true;
        const filters = this.scheduleColumns.filter(col => (col.filter?.crules?.[0] as UserDefaultParameters)?.value).map(col => ({
            dataIndx: col.dataIndx,
            value: (col.filter!.crules![0] as UserDefaultParameters).value
        }));

        const formFilters = {
            truckerId: this.scheduleParameters.truckerId,
            locationName: this.scheduleParameters.locationName,
            locationCity: this.scheduleParameters.locationCity,
            loadDate: this.scheduleParameters.loadDate,
            deliveryDate: this.scheduleParameters.deliveryDate,
            loadNumber: this.scheduleParameters.loadNumber
        };

        const state = {
            filters,
            formFilters
        };

        const jsonValue = JSON.stringify(state);
        const key = "ScheduleFilters";

        const locCode = this.scheduleParameters.locCode;
        this._userDataService.saveUserDefault(locCode, jsonValue, key).subscribe({
            next: () => {
                this.savingDefaultFilters = false;
            },
            error: err => {
                this.errorMessage = err;
                this.savingDefaultFilters = false;
            }
        });
    }


    exportGrid(): void {
        const allData = [];
        let schedules: ScheduleItem[] = this.scheduleOptions.dataModel.data as ScheduleItem[];

        schedules.forEach((schedule, scheduleIndex) => {
            if (schedule.dispatches?.length > 0) {
                schedule.dispatches.forEach((dispatch, dispatchIndex) => {
                    if (dispatch.loadList?.length > 0) {
                        dispatch.loadList.forEach((load, loadIndex) => {
                            allData.push({
                                customerName: load.loadId == dispatch.loadList[0].loadId ? schedule.customerName : "",
                                locationName: load.loadId == dispatch.loadList[0].loadId ? schedule.locationName : "",
                                locationCity: load.loadId == dispatch.loadList[0].loadId ? schedule.locationCity : "",
                                locationState: load.loadId == dispatch.loadList[0].loadId ? schedule.locationState : "",
                                commodityCode: load.loadId == dispatch.loadList[0].loadId ? schedule.commodityCode : "",
                                numberOfLoads: load.loadId == dispatch.loadList[0].loadId ? schedule.loads : "",
                                dispatchedLoads: load.loadId == dispatch.loadList[0].loadId ? schedule.dispatchedLoads : "",
                                balanceLoads: load.loadId == dispatch.loadList[0].loadId ? schedule.balanceLoads : "",
                                unassignedLoads: load.loadId == dispatch.loadList[0].loadId ? schedule.unassignedLoads : "",
                                unconfirmedLoads: load.loadId == dispatch.loadList[0].loadId ? schedule.unconfirmedLoads : "",
                                confirmedLoads: load.loadId == dispatch.loadList[0].loadId ? schedule.confirmedLoads : "",
                                enteredBy: load.loadId == dispatch.loadList[0].loadId ? schedule.enteredBy : "",
                                customerCode: load.loadId == dispatch.loadList[0].loadId ? schedule.customerCode : "",
                                destCode: load.loadId == dispatch.loadList[0].loadId ? schedule.locationCode : "",
                                scheduleId: load.loadId == dispatch.loadList[0].loadId && schedule.scheduleId > 0 ? "S" + schedule.scheduleId : "",
                                truckerName: schedule.dispatches[dispatchIndex].dispatchId == dispatch.dispatchId && loadIndex == 0 ? dispatch.truckerName : "",
                                dcustomerName: schedule.dispatches[dispatchIndex].dispatchId == dispatch.dispatchId && loadIndex == 0 ? dispatch.customerName : "",
                                dLocationName: schedule.dispatches[dispatchIndex].dispatchId == dispatch.dispatchId && loadIndex == 0 ? dispatch.locationName : "",
                                dLocationCity: schedule.dispatches[dispatchIndex].dispatchId == dispatch.dispatchId && loadIndex == 0 ? dispatch.locationCity : "",
                                dLocationState: schedule.dispatches[dispatchIndex].dispatchId == dispatch.dispatchId && loadIndex == 0 ? dispatch.locationState : "",
                                dLoads: schedule.dispatches[dispatchIndex].dispatchId == dispatch.dispatchId && loadIndex == 0 ? dispatch.numberOfLoads : "",
                                dRate: schedule.dispatches[dispatchIndex].dispatchId == dispatch.dispatchId && loadIndex == 0 ? dispatch.rate : "",
                                dLoadNumber: schedule.dispatches[dispatchIndex].dispatchId == dispatch.dispatchId && loadIndex == 0 ? dispatch.loadNumber : "",
                                dUnloadNumber: schedule.dispatches[dispatchIndex].dispatchId == dispatch.dispatchId && loadIndex == 0 ? dispatch.unloadNumber : "",
                                dInternalNotes: schedule.dispatches[dispatchIndex].dispatchId == dispatch.dispatchId && loadIndex == 0 ? dispatch.internalNotes : "",
                                dStatus: schedule.dispatches[dispatchIndex].dispatchId == dispatch.dispatchId && loadIndex == 0 ? dispatch.status : "",
                                dRound: schedule.dispatches[dispatchIndex].dispatchId == dispatch.dispatchId && loadIndex == 0 ? dispatch.round : "",
                                dEnteredBy: schedule.dispatches[dispatchIndex].dispatchId == dispatch.dispatchId && loadIndex == 0 ? dispatch.enteredBy : "",
                                dtruckerCode: schedule.dispatches[dispatchIndex].dispatchId == dispatch.dispatchId && loadIndex == 0 ? dispatch.truckerCode : "",
                                dDispatchId: schedule.dispatches[dispatchIndex].dispatchId == dispatch.dispatchId && loadIndex == 0 && dispatch.dispatchId > 0 ? "D" + dispatch.dispatchId : "",
                                lPickupDate: load.pickupDate,
                                lDay: load.dayOfWeek,
                                lLoadNumber: load.loadNumber,
                                lNotes: load.notes,
                                lDeliveryDate: load.deliveryDate,
                                lDeliveryTime: load.deliveryTime,
                                lPreAdvise: load.preAdvise ? "Y" : "N",
                                lDelivered: load.delivered ? "Y" : "N",
                                lTicket: load.ticket,
                                lDeliveredDate: load.deliveredDate,
                                lFs: load.finalSettled ? "Y" : "N",
                                lUnloadNo: load.unloadNumber,
                                lLoadId: load.loadId > 0 ? "L" + load.loadId : ""
                            })
                        });
                    }
                    else {
                        allData.push({
                            customerName: dispatch.dispatchId == schedule.dispatches[0].dispatchId ? schedule.customerName : "",
                            locationName: dispatch.dispatchId == schedule.dispatches[0].dispatchId ? schedule.locationName : "",
                            locationCity: dispatch.dispatchId == schedule.dispatches[0].dispatchId ? schedule.locationCity : "",
                            locationState: dispatch.dispatchId == schedule.dispatches[0].dispatchId ? schedule.locationState : "",
                            commodityCode: dispatch.dispatchId == schedule.dispatches[0].dispatchId ? schedule.commodityCode : "",
                            numberOfLoads: dispatch.dispatchId == schedule.dispatches[0].dispatchId ? schedule.loads : "",
                            dispatchedLoads: dispatch.dispatchId == schedule.dispatches[0].dispatchId ? schedule.dispatchedLoads : "",
                            balanceLoads: dispatch.dispatchId == schedule.dispatches[0].dispatchId ? schedule.balanceLoads : "",
                            unassignedLoads: dispatch.dispatchId == schedule.dispatches[0].dispatchId ? schedule.unassignedLoads : "",
                            unconfirmedLoads: dispatch.dispatchId == schedule.dispatches[0].dispatchId ? schedule.unconfirmedLoads : "",
                            confirmedLoads: dispatch.dispatchId == schedule.dispatches[0].dispatchId ? schedule.confirmedLoads : "",
                            enteredBy: dispatch.dispatchId == schedule.dispatches[0].dispatchId ? schedule.enteredBy : "",
                            customerCode: dispatch.dispatchId == schedule.dispatches[0].dispatchId ? schedule.customerCode : "",
                            destCode: dispatch.dispatchId == schedule.dispatches[0].dispatchId ? schedule.locationCode : "",
                            scheduleId: dispatch.dispatchId == schedule.dispatches[0].dispatchId && schedule.scheduleId > 0 ? "S" + schedule.scheduleId : "",
                            truckerName: dispatch.truckerName,
                            dcustomerName: dispatch.customerName,
                            dLocationName: dispatch.locationName,
                            dLocationCity: dispatch.locationCity,
                            dLocationState: dispatch.locationState,
                            dRate: dispatch.rate,
                            dLoads: dispatch.numberOfLoads,
                            dLoadNumber: dispatch.loadNumber,//
                            dUnloadNumber: dispatch.unloadNumber,//
                            dInternalNotes: dispatch.internalNotes,
                            dStatus: dispatch.status,
                            dRound: dispatch.round,
                            dEnteredBy: dispatch.enteredBy,
                            dtruckerCode: dispatch.truckerCode,
                            dDispatchId: dispatch.dispatchId > 0 ? "D" + dispatch.dispatchId : "",
                            lPickupDate: "",
                            lDay: "",
                            lLoadNumber: "",
                            lNotes: "",
                            lDeliveryDate: "",
                            lDeliveryTime: "",
                            lPreAdvise: "",
                            lDelivered: "",
                            lTicket: "",
                            lDeliveredDate: "",
                            lFs: "",
                            lUnloadNo: "",
                            lLoadId: ""
                        })
                    }
                });
            }
            else {
                allData.push({
                    customerName: schedule.customerName,
                    locationName: schedule.locationName,
                    locationCity: schedule.locationCity,
                    locationState: schedule.locationState,
                    commodityCode: schedule.commodityCode,
                    numberOfLoads: schedule.loads,//
                    dispatchedLoads: schedule.dispatchedLoads,
                    balanceLoads: schedule.balanceLoads,
                    unassignedLoads: schedule.unassignedLoads,
                    unconfirmedLoads: schedule.unconfirmedLoads,
                    confirmedLoads: schedule.confirmedLoads,
                    enteredBy: schedule.enteredBy,
                    customerCode: schedule.customerCode,
                    destCode: schedule.locationCode,
                    scheduleId: schedule.scheduleId > 0 ? "S" + schedule.scheduleId : "",
                    truckerName: "",
                    dcustomerName: "",
                    dLocationName: "",
                    dLocationCity: "",
                    dLocationState: "",
                    dLoads: "",
                    dRate: "",
                    dLoadNumber: "",
                    dUnloadNumber: "",
                    dInternalNotes: "",
                    dStatus: "",
                    dRound: "",
                    dEnteredBy: "",
                    dtruckerCode: "",
                    dDispatchId: "",
                    lPickupDate: "",
                    lDay: "",
                    lLoadNumber: "",
                    lNotes: "",
                    lDeliveryDate: "",
                    lDeliveryTime: "",
                    lPreAdvise: "",
                    lDelivered: "",
                    lTicket: "",
                    lDeliveredDate: "",
                    lFs: "",
                    lUnloadNo: "",
                    lLoadId: ""
                });
            }
            allData.push({});
        });

        const exportColModel = [];

        //Schedules
        {
            exportColModel.push(
                { title: "Customer Name", dataIndx: "customerName", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' }, style: { 'font-weight': 'bold' } },
            );

            if (this.scheduleParameters.locationType === LocationType.Destination) {
                exportColModel.push(
                    { title: "Destination", dataIndx: "locationName", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' }, style: { 'font-weight': 'bold' } },
                );
            }
            else {
                exportColModel.push(
                    { title: "Origin", dataIndx: "locationName", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                );
            }
            exportColModel.push(
                { title: "City", dataIndx: "locationCity", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "State", dataIndx: "locationState", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Commodity", dataIndx: "commodityCode", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Loads", dataIndx: "numberOfLoads", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Dispatched Loads", dataIndx: "dispatchedLoads", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Balance Loads", dataIndx: "balanceLoads", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Unassigned Loads", dataIndx: "unassignedLoads", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Unconfirmed Loads", dataIndx: "unconfirmedLoads", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Confirmed Loads", dataIndx: "confirmedLoads", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Entered By", dataIndx: "enteredBy", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Customer Code", dataIndx: "customerCode", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Dest Code", dataIndx: "destCode", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Schedule Id", dataIndx: "scheduleId", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' }, style: { 'background-color': '#ecf6ff', 'font-weight': 'bold' } }
            );
        }

        //Dispatches
        {
            exportColModel.push(
                { title: "Trucker", dataIndx: "truckerName", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' }, style: { 'font-weight': 'bold' } },
                { title: "Customer", dataIndx: "dcustomerName", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' }, style: { 'font-weight': 'bold' } },
            );

            if (this.scheduleParameters.locationType === LocationType.Destination) {
                exportColModel.push(
                    { title: "Origin", dataIndx: "dLocationName", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                );
            }
            else {
                exportColModel.push(
                    { title: "Destination", dataIndx: "locationName", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' }, style: { 'font-weight': 'bold' } },
                );
            }

            exportColModel.push(
                { title: "City", dataIndx: "dLocationCity", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "ST", dataIndx: "dLocationState", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Loads", dataIndx: "dLoads", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Rate", dataIndx: "dRate", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Unload #", dataIndx: "dUnloadNumber", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Load #", dataIndx: "dLoadNumber", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Internal Notes", dataIndx: "dInternalNotes", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Status", dataIndx: "dStatus", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Round", dataIndx: "dRound", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Entered By", dataIndx: "dEnteredBy", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Trucker Code", dataIndx: "dtruckerCode", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Dispatch Id", dataIndx: "dDispatchId", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' }, style: { 'background-color': '#ecf6ff' } }
            );
        }

        //Loads
        {
            exportColModel.push(
                { title: "Load Date", dataIndx: "lPickupDate", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Day", dataIndx: "lDay", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Load #", dataIndx: "lLoadNumber", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Notes", dataIndx: "lNotes", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Delivery Date", dataIndx: "lDeliveryDate", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Delivery Time", dataIndx: "lDeliveryTime", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "PA", dataIndx: "lPreAdvise", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Divd", dataIndx: "lDelivered", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Ticket #", dataIndx: "lTicket", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Delivered Date", dataIndx: "lDeliveredDate", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "FS", dataIndx: "lFs", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Unload #", dataIndx: "lUnloadNo", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } },
                { title: "Load ID", dataIndx: "lLoadId", styleHead: { 'font-weight': 'bold', 'background-color': '#5987D6', 'color': '#ffffff' } }
            );
        }

        const groupModel = {
            on: false,
            dataIndx: ['scheduleId', 'dDispatchId'],
            collapsed: [false, false],
            title: [
                "{0} ({1})",
                "{0} - {1}"
            ]
        };

        // Export the data
        const exportOptions = {
            render: true,
            sheetName: "schedules",
            format: "xlsx",
            includeCollapsed: true,
            rowData: allData,
            colModel: exportColModel
        };

        const tempGrid = pq.grid("<div></div>", {
            colModel: exportColModel,
            dataModel: { data: allData },
            groupModel: groupModel,
            numberCell: { show: false }, // Hide the row number column to avoid width issues
            scrollModel: { autoFit: false }, // Ensure autoFit is not overriding widths
            columnBorders: true, // Enable column borders for better visibility
            resizable: true, // Ensure columns are resizable
        });

        const blob = tempGrid.exportExcel(exportOptions);
        pq.saveAs(blob, 'schedules-export.xlsx');
    }

    getDispatchGrid(data): any {
        let dispatchOptions = this.getDispatchOptions(data);

        //hook up button click events
        let self = this;
        dispatchOptions.colModel[1].postRender = function (ui) {
            var scheduleId = ui.rowData.scheduleId;
            var dispatchId = ui.rowData.dispatchId;
            var truckerId = ui.rowData.truckerId;
            var truckerName = ui.rowData.truckerName;
            var roundId = ui.rowData.roundId;
            var rogerStatus = ui.rowData.rogerStatus;
            var hasTextMessage = ui.rowData.hasTextMessage;

            var $cell = this.getCell(ui);
            var $editBtn = $cell.find('.edit-btn');
            var $copyBtn = $cell.find('.copy-btn');
            var $deleteBtn = $cell.find('.delete-btn');
            var $alertTruckerBtn = $cell.find('.alert-trucker-btn');
            var $moveSplitBtn = $cell.find('.move-split-btn');
            var $emailQuestionBtn = $cell.find('.question-email-btn');
            var $roundBtn = $cell.find('.round-btn');
            var $copyRoundBtn = $cell.find('.copy-round-btn')
            var $sendBtn = $cell.find('.send-btn');
            var $rogerBtn = $cell.find('.roger-btn');
            var $textBtn = $cell.find('.text-btn');

            //var $menuBtn = $cell.find('.menu-btn');
            //var $menuItems = $cell.find('.menu-items');
            //$menuBtn.on('click', function () {
            //    $menuItems.toggle();
            //    return false;
            //});
       
            $editBtn.on('click', function () {
                self.editDispatch(scheduleId, dispatchId);
            });
            $copyBtn.on('click', function () {
                self.copyDispatch(dispatchId);
            });
            $deleteBtn.on('click', function () {
                self.deleteDispatch(scheduleId, dispatchId, truckerName);
                return false;
            });
            $alertTruckerBtn.on('click', function () {
                self.alertTrucker(scheduleId, dispatchId, truckerId, false);
                return false;
            });
            $moveSplitBtn.on('click', function () {
                self.moveSplitDispatch(scheduleId, dispatchId);
                return false;
            });
            $emailQuestionBtn.on('click', function () {
                self.getEmailQuestionDetails(scheduleId, dispatchId);
                return false;
            });
            if (hasTextMessage) {
                $textBtn.on('click', function () {
                    self.showTextsStatus(dispatchId);
                    return false;
                });
            }
            $roundBtn.on('click', function () {
                self.openRound(roundId, dispatchId);
            });
            $copyRoundBtn.on('click', function () {
                self.openRound(roundId, dispatchId);
            });
            if (truckerId > 0) {
                $sendBtn.on('click', function () {
                    self.sendDispatch(dispatchId);
                });
            }
            else {
                $sendBtn.hide();
            }
            if (rogerStatus.length > 0) {
                $rogerBtn.on('click', function () {
                    self.showRogerLoadsStatus(dispatchId);
                });
            }
            else {
                $rogerBtn.hide();
            }
        };

        //this was commented out but kept if needed. It will hide the dispatch buttons unless in the correct Plan By perspective. Needs to wrap the code above.
        //if (scheduleId > 0) {
        //
        //} else {
        //    $editBtn.hide();
        //    $copyBtn.hide();
        //    $deleteBtn.hide();
        //    $alertTruckerBtn.hide();
        //    $moveSplitBtn.hide();
        //    $emailQuestionBtn.hide();
        //    $roundBtn.hide();
        //    $copyRoundBtn.hide();
        //    $sendBtn.hide();
        //    $rogerBtn.hide();
        //}

        let gridHtml = '<div class="dispatch-grid grid-level-2 mb-2"></div>';
        if (data.length == 0) {
            gridHtml = '<div class="hidden"></div>'
        }
        return $(gridHtml).pqGrid(dispatchOptions);
    }

    getDispatchOptions(data): pq.gridT.options {
        return {
            showTop: false,
            reactive: true,
            locale: "en",
            height: "flex",
            fillHandle: "",
            freezeCols: 2,
            resizable: true,
            numberCell: {
                show: false
            },
            columnTemplate: { width: 100 },
            colModel: this.dispatchColumns,
            animModel: {
                on: false
            },
            dataModel: {
                data: data
            },
            detailModel: {
                header: true,
                init: (ui: any) => {
                    let loadsGrid = this.getLoadsGrid(ui.rowData.loadList, ui.rowData.loadBreakout);
                    return loadsGrid;
                }
            },
            sortModel: {
                cancel: true,
                type: "local",
                single: false,
                space: true
            },
            filterModel: {
                header: true,
                menuIcon: false
            },
            beforePaste: function (event) {
                event.preventDefault();
            },
            postRenderInterval: -1
        }
    }

    getLoadsGrid(data: Load[], loadBreakout: boolean): any {
        data.forEach(load => {
            const match = this.equipmentTypes.find(e => e.equipmentCode === load.equipmentType);
            if (match) load.equipmentType = match.description;
        });

        let loadsOptions = this.getLoadsOptions(data, loadBreakout);

        //grid change event to save updates made in grid
        let self = this;
        loadsOptions.change = function (evt, ui) {
            self.gridLoadChange(evt, ui);
        }

        //button events
        if (loadBreakout) {
            loadsOptions.colModel[1].postRender = function (ui) {
                var dispatchId = ui.rowData.dispatchId;
                var loadId = ui.rowData.loadId;
                var loadDate = ui.rowData.pickupDate;
                var deliveryDate = ui.rowData.deliveryDate;

                var $cell = this.getCell(ui);
                var $deleteBtn = $cell.find('.delete-btn');
                var $loadBtn = $cell.find('.load-btn');
                var $unloadBtn = $cell.find('.unload-btn');
                $deleteBtn.on('click', function () {
                    self.deleteLoad(dispatchId, loadId, loadDate, deliveryDate);
                    return false;
                });
                $loadBtn.on('click', function () {
                    self.openLoadBank(dispatchId, loadId, 0);
                });
                $unloadBtn.on('click', function () {
                    self.openLoadBank(dispatchId, loadId, 1);
                });
            };
        }

        return $('<div class="loads-grid grid-level-3 mb-2"></div>').pqGrid(loadsOptions);
    }

    getLoadsOptions(data: Load[], loadBreakout: boolean): pq.gridT.options {
        let loadColumns: any[] = loadBreakout ? this.loadColumns : this.loadNoEditColumns;
        const equipmentDataIndexes = ['equipmentType', 'equipmentWeight', 'equipmentWeightUOM'];
        loadColumns.forEach(col => {
            if (equipmentDataIndexes.includes(col.dataIndx)) {
                col.hidden = !this.showEquipmentFields;
            }
        });
        const self = this;

        return {
            showTop: false,
            reactive: true,
            locale: "en",
            height: "flex",
            fillHandle: "",
            editModel: {
                clicksToEdit: 1
            },
            resizable: true,
            numberCell: {
                show: false
            },
            columnTemplate: {
                width: 100,
            },
            colModel: loadColumns,
            animModel: {
                on: false
            },
            dataModel: {
                data: data

            },
            sortModel: {
                cancel: true,
                type: "local",
                single: true,
                space: true
            },

            beforePaste: function (event, ui) {
                const rowCount = ui.rows.length;
                const colCount = ui.rows[0]?.length;
                const areas = ui.areas;

                if (areas && areas.length > 0) {
                    const { r1, r2, c1, c2 } = areas[0];
                    const selectedRowCount = r2 - r1 + 1;
                    const selectedColCount = c2 - c1 + 1;

                    if (rowCount > selectedRowCount || colCount > selectedColCount || colCount !== selectedColCount) {
                        self.toastNotification.showToast("Invalid: The pasted data doesn't match the size of the selected area.", 3000, "error");
                        event.preventDefault();
                    } 
                }
            },

            postRenderInterval: -1
        }
    }

    openLoadBank(dispatchId: number, loadId: number, loadBankType: LoadBankType) {
        let parameters = new LoadBankApplyParameters();
        parameters.locCode = this.scheduleParameters.locCode;
        parameters.dispatchId = dispatchId;
        parameters.loadBankType = loadBankType;
        let selectedLoadIds = this.getSelectedLoads(dispatchId);
        if (selectedLoadIds.length > 0) {
            parameters.loadIds = selectedLoadIds;
        }
        else {
            parameters.loadIds.push(loadId);
        }
        this.loadBankApplyParameters = parameters;

        return false;
    }

    getSelectedLoads(dispatchId: number): number[] {
        let selectedLoadIds: number[] = [];
        let schedules: ScheduleItem[] = this.scheduleOptions.dataModel.data as ScheduleItem[];
        for (let schedule of schedules) {
            let dispatch: DispatchItem | undefined = schedule.dispatches.find(d => d.dispatchId == dispatchId);
            if (dispatch !== undefined) {
                let selectedLoads = dispatch.loadList.filter(item => item.selected);
                selectedLoadIds = selectedLoads.map(item => item.loadId);
                break;
            }
        }
        return selectedLoadIds;
    }

    loadBankApplyComplete(dispatchId: number) {
        this.refreshDispatch(dispatchId);
    }

    clearSorting() {
        this.scheduleGrid.grid.reset({ sort: true });
    }

    getScheduleChangeData(ui): ScheduleLoads {
        let scheduleLoads = new ScheduleLoads();
        let schedule = ui.updateList[0].rowData as ScheduleItem;
        scheduleLoads.scheduleId = schedule.scheduleId;
        let newRow = ui.updateList[0].newRow;

        if ('loads' in newRow) {
            scheduleLoads.loads = schedule.loads;
        }
        else {
            for (let i = 0; i <= 6; i++) {
                let fieldName = 'planLoads' + i;
                if (fieldName in newRow) {
                    scheduleLoads.loads = schedule[fieldName];
                    scheduleLoads.startDate = this.scheduleParameters.periodStartDate;
                    scheduleLoads.dayNumber = i + 1;
                    if (schedule.dailyLoads.length > i) {
                        scheduleLoads.actualLoads = schedule.dailyLoads[i];
                    }
                    break;
                }
            }
        }

        return scheduleLoads;
    }

    gridScheduleChange(evt, ui) {
        let scheduleLoads = this.getScheduleChangeData(ui);

        if (scheduleLoads.scheduleId == 0) {
            return;
        }

        this._scheduleDataService.saveScheduleLoads(scheduleLoads).subscribe({
            next: data => {

            },
            error: err => this.errorMessage = err
        });

        //calculate and refresh loads balance
        let index = ui.updateList[0].rowIndx;
        let schedule = this.scheduleOptions.dataModel.data[index] as ScheduleItem;
        if (schedule && !isNaN(schedule.loads) && !isNaN(schedule.dispatchedLoads)) {
            schedule.balanceLoads = schedule.loads - schedule.dispatchedLoads;
            this.scheduleGrid.grid.refreshCell({ rowIndx: index, dataIndx: 'balanceLoads' });
        }
    }

    gridLoadChange(evt, ui) {
        let isSelectChange = ui.updateList[0].newRow.selected !== undefined;

        if (!isSelectChange) {
            let saveCompleteCount = 0;
            let hasDateChange = false;
            let hasExecutionChange = false;

            ui.updateList.forEach(updateItem => {
                hasDateChange = ('pickupDate' in updateItem.newRow) || ('deliveryDate' in updateItem.newRow);
                hasExecutionChange = hasExecutionChange || ('preAdvise' in updateItem.newRow) || ('delivered' in updateItem.newRow);
                let load = updateItem.rowData as Load;

                if ('equipmentType' in updateItem.newRow) {
                    const selected = this.equipmentTypes.find(e => e.description === load.equipmentType);
                    if (selected) {
                        load.equipmentType = selected.equipmentCode;
                        if (selected.defaultWeight !== null) {
                            load.equipmentWeight = selected.defaultWeight.toFixed(3);
                            load.equipmentWeightUOM = selected.weightUOM ?? '';
                        } else {
                            load.equipmentWeight = '';
                            load.equipmentWeightUOM = '';
                        }
                        this.scheduleGrid.grid.updateRow({
                            rowIndx: updateItem.rowIndx,
                            newRow: { equipmentWeight: load.equipmentWeight, equipmentWeightUOM: load.equipmentWeightUOM },
                            history: false
                        });
                    } else if (load.equipmentType === '') {
                        load.equipmentWeight = '';
                        load.equipmentWeightUOM = '';
                        this.scheduleGrid.grid.updateRow({
                            rowIndx: updateItem.rowIndx,
                            newRow: { equipmentWeight: load.equipmentWeight, equipmentWeightUOM: load.equipmentWeightUOM },
                            history: false
                        });
                    } else {
                        this.toastNotification.showToast("Invalid: Equipment Type is not a valid option. Reverting.", 3000, "error");
                        load.equipmentType = updateItem.oldRow.equipmentType;
                        load.equipmentWeight = updateItem.oldRow.equipmentWeight;
                        load.equipmentWeightUOM = updateItem.oldRow.equipmentWeightUOM;
                        this.scheduleGrid.grid.updateRow({
                            rowIndx: updateItem.rowIndx,
                            newRow: {
                                equipmentType: updateItem.oldRow.equipmentType,
                                equipmentWeight: updateItem.oldRow.equipmentWeight,
                                equipmentWeightUOM: updateItem.oldRow.equipmentWeightUOM
                            },
                            history: false
                        });
                        return;
                    }
                }

                if ('driverName' in updateItem.newRow && load.driverName?.length > 50) {
                    this.toastNotification.showToast("Invalid: Driver Name cannot exceed 50 characters. Reverting.", 3000, "error");
                    load.driverName = updateItem.oldRow.driverName;
                    this.scheduleGrid.grid.updateRow({
                        rowIndx: updateItem.rowIndx,
                        newRow: { driverName: updateItem.oldRow.driverName },
                        history: false
                    });
                    return;
                }

                if ('licensePlateNumber' in updateItem.newRow && load.licensePlateNumber?.length > 50) {
                    this.toastNotification.showToast("Invalid: License Plate cannot exceed 50 characters. Reverting.", 3000, "error");
                    load.licensePlateNumber = updateItem.oldRow.licensePlateNumber;
                    this.scheduleGrid.grid.updateRow({
                        rowIndx: updateItem.rowIndx,
                        newRow: { licensePlateNumber: updateItem.oldRow.licensePlateNumber },
                        history: false
                    });
                    return;
                }

                if ('equipmentWeight' in updateItem.newRow && load.equipmentWeight !== '') {
                    const parsed = parseFloat(load.equipmentWeight);
                    if (isNaN(parsed)) {
                        this.toastNotification.showToast("Invalid: Equipment Weight must be a number. Reverting.", 3000, "error");
                        load.equipmentWeight = updateItem.oldRow.equipmentWeight;
                        this.scheduleGrid.grid.updateRow({
                            rowIndx: updateItem.rowIndx,
                            newRow: { equipmentWeight: updateItem.oldRow.equipmentWeight },
                            history: false
                        });
                        return;
                    }
                    const formatted = parsed.toFixed(3);
                    if (formatted !== load.equipmentWeight) {
                        load.equipmentWeight = formatted;
                        this.scheduleGrid.grid.updateRow({
                            rowIndx: updateItem.rowIndx,
                            newRow: { equipmentWeight: formatted },
                            history: false
                        });
                    }
                }

                //needed or else initial attempt to change date will not persist
                const pickup = new Date(load.pickupDate);
                const delivery = new Date(load.deliveryDate);

                if (delivery < pickup) {
                    if ('pickupDate' in updateItem.newRow) {
                        this.toastNotification.showToast("Invalid: Pickup Date cannot be after Delivery Date. Reverting Pickup Date.", 3000, "error");
                        load.pickupDate = updateItem.oldRow.pickupDate;
                        this.scheduleGrid.grid.updateRow({
                            rowIndx: updateItem.rowIndx,
                            newRow: { pickupDate: updateItem.oldRow.pickupDate },
                            history: false
                        });
                    }
                    if ('deliveryDate' in updateItem.newRow) {
                        this.toastNotification.showToast("Invalid: Delivery Date cannot be before Pickup Date. Reverting Delivery Date.", 3000, "error");
                        load.deliveryDate = updateItem.oldRow.deliveryDate;
                        this.scheduleGrid.grid.updateRow({
                            rowIndx: updateItem.rowIndx,
                            newRow: { deliveryDate: updateItem.oldRow.deliveryDate },
                            history: false
                        });
                    }
                    return;
                }

                // Convert equipment type from description to code before saving
                const equipMatch = this.equipmentTypes.find(e => e.description === load.equipmentType);
                if (equipMatch) load.equipmentType = equipMatch.equipmentCode;

                this._scheduleDataService.saveLoad(load).subscribe({
                    next: data => {
                        // Convert equipment type back to description for display
                        const match = this.equipmentTypes.find(e => e.equipmentCode === load.equipmentType);
                        if (match) load.equipmentType = match.description;
                        saveCompleteCount++;
                        if (saveCompleteCount == ui.updateList.length) {
                            //if showing daily loads and made a load date change then refresh the schedule to update the load plan columns
                            if (this.showLoadsByDay && hasDateChange && load.scheduleId > 0) {
                                this.refreshSchedule(load.scheduleId, load.dispatchId);
                            }
                            // Refresh parent rows when execution status changes (PA/Dlvd checkboxes)
                            if (hasExecutionChange && load.scheduleId > 0) {
                                this.refreshExecutedColumns(load.scheduleId, load.dispatchId);
                            }
                        }
                    },
                    error: err => this.errorMessage = err
                });
            });
        }
    }

    private refreshExecutedColumns(scheduleId: number, dispatchId: number): void {
        const schedules = this.scheduleOptions.dataModel.data as ScheduleItem[];
        const scheduleIndex = schedules.findIndex(s => s.scheduleId === scheduleId);
        if (scheduleIndex > -1) {
            // Refresh schedule row to update its Executed column
            this.scheduleGrid.grid.refreshRow({ rowIndx: scheduleIndex });

            // Refresh dispatch row if the schedule is expanded
            const scheduleRowData = schedules[scheduleIndex] as any;
            if (scheduleRowData.pq_detail?.child) {
                const dispatchGrid = $(scheduleRowData.pq_detail.child).pqGrid('instance');
                const dispatchIndex = scheduleRowData.dispatches.findIndex(
                    (d: DispatchItem) => d.dispatchId === dispatchId
                );
                if (dispatchIndex > -1) {
                    dispatchGrid.refreshRow({ rowIndx: dispatchIndex });
                }
            }
        }
    }

    getScheduleDefaults(): ScheduleDefaults {
        let defaults: ScheduleDefaults = new ScheduleDefaults();
        defaults.scheduleId = 0;
        defaults.locationType = this.scheduleParameters.locationType;
        defaults.locCode = this.scheduleParameters.locCode;
        defaults.periodStartDate = this.scheduleParameters.periodStartDate;
        defaults.periodEndDate = this.scheduleParameters.periodEndDate;
        return defaults;
    }

    newSchedule() {
        this.scheduleForm = this.getScheduleDefaults();
    }

    openAlertTrucker() {
        this.alertTrucker(0, 0, 0, true);
        this.alertTruckerForm.locationType = this.scheduleParameters.locationType;
        this.alertTruckerForm.locCode = this.scheduleParameters.locCode;
    }

    editSchedule(scheduleId: number) {
        let defaults = this.getScheduleDefaults();
        defaults.scheduleId = scheduleId;
        this.scheduleForm = defaults;
    }

    newDispatch(scheduleId: number) {
        let parms = new DispatchParameters();
        parms.locCode = this.scheduleParameters.locCode;
        parms.scheduleId = scheduleId;
        this.dispatchForm = parms;
    }

    editDispatch(scheduleId: number, dispatchId: number) {
        let parms = new DispatchParameters();
        parms.locCode = this.scheduleParameters.locCode;
        parms.scheduleId = scheduleId;
        parms.dispatchId = dispatchId;
        this.dispatchForm = parms;
    }

    copyDispatch(dispatchId: number) {
        let parms = new CopyDispatchParameters();
        parms.locCode = this.scheduleParameters.locCode;
        parms.planPeriod = this.scheduleParameters.planPeriod;
        parms.periodStartDate = this.scheduleParameters.periodStartDate;
        parms.periodEndDate = this.scheduleParameters.periodEndDate;
        parms.dispatchId = dispatchId;
        this.copyDispatchParameters = parms;
    }

    openRound(roundId: number, dispatchId: number) {
        let parms = new RoundParameters();
        parms.roundId = roundId;
        parms.dispatchId = dispatchId;
        parms.locCode = this.scheduleParameters.locCode;
        parms.planPeriod = this.scheduleParameters.planPeriod;
        parms.periodStartDate = this.scheduleParameters.periodStartDate;
        parms.periodEndDate = this.scheduleParameters.periodEndDate;
        this.roundParameters = parms;
    }

    roundComplete(eventParms: RoundCompleteEvent) {
        this.refreshScheduleList(eventParms.scheduleIds);
        this._scheduleDataService.getTruckerListForSchedules(this.scheduleParameters).subscribe({
            next: data => {
                this.truckerList = data;
            },
            error: err => this.errorMessage = err
        });
        if (eventParms.message.length > 0) {
            this.toastNotification.showToast(eventParms.message, 3000, "success");
        }
    }

    alertTrucker(scheduleId: number, dispatchId: number, truckerId: number, isRequestFromSendTextAlertForm: boolean) {
        let parms = new AlertParameters();
        parms.scheduleId = scheduleId;
        parms.dispatchId = dispatchId;
        parms.truckerId = truckerId;
        //parms.truckerName = truckerName;
        parms.periodStartDate = this.scheduleParameters.periodStartDate;
        parms.periodEndDate = this.scheduleParameters.periodEndDate;
        //parms.customerId = this.scheduleParameters.customerId;
        parms.selectedLocCodeInFilter = this.scheduleParameters.locCode;
        parms.isRequestFromSendTextAlertForm = isRequestFromSendTextAlertForm;
        this.alertTruckerForm = parms;
    }

    sendDispatch(dispatchId: number) {
        this.sendDispatchId = dispatchId;
        this.sendDispatchRefresh = !this.sendDispatchRefresh;
    }

    confirmTruckers() {
        this.sendDispatchRefresh = !this.sendDispatchRefresh;
    }

    confirmOrigin() {
        let confirmInfo = this.createLocationConfirmInfo();
        confirmInfo.locationType = LocationType.Origin;
        this.locationConfirmInfo = confirmInfo;
    }

    confirmDestination() {
        let confirmInfo = this.createLocationConfirmInfo();
        confirmInfo.locationType = LocationType.Destination;
        this.locationConfirmInfo = confirmInfo;
    }

    createLocationConfirmInfo(): LocationConfirmInfo {
        let confirmInfo = new LocationConfirmInfo();
        confirmInfo.locCode = this.scheduleParameters.locCode;
        confirmInfo.periodStartDate = this.scheduleParameters.periodStartDate;
        confirmInfo.periodEndDate = this.scheduleParameters.periodEndDate;
        return confirmInfo;
    }

    showRogerLoadsStatus(dispatchId: number) {
        this.loadsStatusDispatchId = dispatchId;
        this.loadsStatusRefresh = !this.loadsStatusRefresh;
        return false;
    }

    showTextsStatus(dispatchId: number) {
        this.textsStatusDispatchId = dispatchId;
        this.textsStatusRefresh = !this.textsStatusRefresh;
        return false;
    }

    moveSplitDispatch(scheduleId: number, dispatchId: number) {
        let parms = new MoveSplitDispatchParameters()
        parms.scheduleId = scheduleId;
        parms.dispatchId = dispatchId;
        parms.periodStartDate = this.scheduleParameters.periodStartDate;
        parms.periodEndDate = this.scheduleParameters.periodEndDate;
        parms.planPeriod = this.scheduleParameters.planPeriod;
        parms.scheduleParameters = { ...this.scheduleParameters };
        parms.scheduleParameters.truckerId = 0;
        parms.scheduleParameters.locationId = 0;
        parms.scheduleParameters.loadDate = "";
        parms.scheduleParameters.deliveryDate = "";
        this.moveSplitDispatchFormParams = parms;
        parms.locCode = this.scheduleParameters.locCode;
        parms.locationType = this.scheduleParameters.locationType;
    }

    getEmailQuestionDetails(scheduleId: number, dispatchId: number) {
        let parms = new EmailQuestionFormParameters()
        parms.scheduleId = scheduleId;
        parms.dispatchId = dispatchId;
        parms.periodStartDate = this.scheduleParameters.periodStartDate;
        parms.periodEndDate = this.scheduleParameters.periodEndDate;
        parms.locationType = this.scheduleParameters.locationType;
        this.emailQuestionForm = parms;
    }

    dontRefresh: boolean = false;
    scheduleSaveComplete(scheduleId: number) {
        this.refreshSchedule(scheduleId);
        this.dontRefresh = true;
        this.getDispatchFilterLists();
    }

    scheduleDeleteComplete(scheduleId: number) {
        this.removeScheduleFromGrid(scheduleId);
        this.dontRefresh = true;
        this.getDispatchFilterLists();
    }

    deleteScheduleItem(scheduleId: number) {
        this._scheduleDataService.deleteSchedule(scheduleId).subscribe({
            next: result => {
                if (result) {
                    this.deleteComponent.close();
                    this.removeScheduleFromGrid(scheduleId);
                    this.deleteItemParams = new DeleteParameters();
                    this.dontRefresh = true;
                    this.getDispatchFilterLists();
                }
            },
            error: err => this.errorMessage = err
        });
        return false;
    }

    deleteDispatchItem(dispatchId: number) {
        this._scheduleDataService.deleteDispatch(dispatchId).subscribe({
            next: result => {
                if (result) {
                    this.deleteComponent.close();
                    this.refreshScheduleList(result);
                    this.deleteItemParams = new DeleteParameters();
                    this.dontRefresh = true;
                    this.getDispatchFilterLists();
                }
            },
            error: err => this.errorMessage = err
        });
    }

    deleteSchedule(scheduleId: number, customerName: string, locationInfo: string) {
        let parms = new DeleteParameters();
        parms.scheduleId = scheduleId;
        parms.title = `Are you sure you want to delete the schedule for ${customerName} @ ${locationInfo}?`
        this.deleteItemParams = parms;
        this.isDeleteConfirmed = false;
        return false;
    }

    deleteDispatch(scheduleId: number, dispatchId: number, truckerName) {
        let parms = new DeleteParameters()
        parms.scheduleId = scheduleId;
        parms.dispatchId = dispatchId;
        parms.title = `Are you sure you want to delete the dispatch for ${truckerName}?`;
        this.deleteItemParams = parms;
        this.isDeleteConfirmed = false;
    }

    deleteLoad(dispatchId: number, loadId: number, loadDate: string, deliveryDate: string) {
        let parms = new DeleteParameters()
        parms.dispatchId = dispatchId;
        parms.loadId = loadId;
        if (loadDate && loadDate.length > 0) {
            parms.title = `Are you sure you want to delete the load with load date ${loadDate}?`;
        }
        else if (deliveryDate && deliveryDate.length > 0) {
            parms.title = `Are you sure you want to delete the load with delivery date ${deliveryDate}?`;
        }
        else {
            parms.title = 'Are you sure you want to delete the selected load?';
        }
        this.deleteItemParams = parms;
        this.isDeleteConfirmed = false;
    }    

    deleteItem(event: boolean, deleteItem: DeleteParameters) {
        if (!event) {
            return;
        }

        if (this.isDeleteConfirmed) {
            this.deleteConfirmedItem(deleteItem);
        }
        else {
            this._scheduleDataService.getRogerInProcessLoadCount(deleteItem).subscribe({
                next: loadCount => {
                    if (loadCount > 0) {
                        if (deleteItem.loadId > 0) {
                            deleteItem.title = `This load cannot be cancelled in Roger. It needs to be handled manually in Roger and with the trucker. Are you sure you want to delete the load?`;
                        }
                        else if (deleteItem.dispatchId > 0) {
                            deleteItem.title = loadCount == 1 ?
                                'This dispatch includes a load that cannot be cancelled in Roger. The load needs to be handled manually in Roger and with the trucker. Are you sure you want to delete the dispatch?' :
                                `This dispatch includes ${loadCount} loads that cannot be cancelled in Roger. The ${loadCount} loads need to be handled manually in Roger and with the trucker. Are you sure you want to delete the dispatch?`;
                        }
                        else if (deleteItem.scheduleId > 0) {
                            deleteItem.title = loadCount == 1 ?
                                'This schedule includes a load that cannot be cancelled in Roger.  The load needs to be handled manually in Roger and with the trucker.  Are you sure you want to delete the schedule?' :
                                `This schedule includes ${loadCount} loads that cannot be cancelled in Roger.  The ${loadCount} loads need to be handled manually in Roger and with the trucker.  Are you sure you want to delete the schedule?`;
                        }
                        this.deleteItemParams = deleteItem;
                        this.deleteComponent.cancel();
                        this.isDeleteConfirmed = true;
                    }
                    else {
                        this.deleteConfirmedItem(deleteItem);
                    }
                },
                error: error => {
                    console.error('Error getting Roger load status:', error);
                }
            });
        }

    }

    deleteConfirmedItem(deleteItem: DeleteParameters) {
        if (deleteItem.loadId > 0) {
            this.deleteLoadItem(deleteItem.dispatchId, deleteItem.loadId);
        }
        else if (deleteItem.dispatchId > 0) {
            this.deleteDispatchItem(deleteItem.dispatchId);
        }
        else if (deleteItem.scheduleId > 0) {
            this.deleteScheduleItem(deleteItem.scheduleId);
        }
    }

    deleteLoadItem(dispatchId: number, loadId: number) {
        this._scheduleDataService.deleteLoad(loadId).subscribe({
            next: scheduleId => {
                if (scheduleId) {
                    this.deleteComponent.close();
                    this.refreshSchedule(scheduleId, dispatchId);
                    this.deleteItemParams = new DeleteParameters();
                }
            },
            error: err => this.errorMessage = err
        });
    }

    removeScheduleFromGrid(scheduleId: number) {
        let index = 0;
        let gridSchedules = this.scheduleOptions.dataModel.data as ScheduleItem[];
        for (let gridSchedule of gridSchedules) {
            if (gridSchedule.scheduleId == scheduleId) {
                this.scheduleOptions.dataModel.data.splice(index, 1);
                this.scheduleGrid.grid.refreshDataAndView();
                //this.scheduleGrid.grid.refreshRow({ rowIndx: index });
                break;
            }
            index++;
        }
        this.onGridFilter();
    }

    refreshScheduleList(scheduleIds: number[]) {
        if (scheduleIds == null) {
            return;
        }
        let schedules: ScheduleItem[] = this.scheduleOptions.dataModel.data as ScheduleItem[];
        for (let scheduleId of scheduleIds) {
            let scheduleIndex: number = schedules.findIndex(s => s.scheduleId == scheduleId);
            if (scheduleIndex > -1) {
                this.refreshSchedule(scheduleId, 0, false);
            }
        }
    }

    refreshSchedule(scheduleId: number, dispatchId: number = 0, refreshAllDispatches: boolean = false) {
        const scheduleRequest = new ScheduleRequest();
        scheduleRequest.scheduleId = scheduleId;
        scheduleRequest.locCode = this.scheduleParameters.locCode;
        scheduleRequest.periodStartDate = this.scheduleParameters.periodStartDate;
        this._scheduleDataService.getScheduleItem(scheduleRequest).subscribe({
            next: data => {
                this.refreshGridSchedule(data, dispatchId);
                if (refreshAllDispatches && data.dispatches) {
                    data.dispatches.forEach(dispatch => {
                        this.refreshDispatch(dispatch.dispatchId);
                    });
                }
            },
            error: err => this.errorMessage = err
        });
    }

    refreshGridSchedule(schedule: ScheduleItem, dispatchId: number = 0) {
        let newSchedule = true;

        let gridSchedules: ScheduleItem[] = this.scheduleOptions.dataModel.data as ScheduleItem[];
        let scheduleIndex: number = gridSchedules.findIndex(s => s.scheduleId == schedule.scheduleId);
        if (scheduleIndex > -1) {
            newSchedule = false;
            this.scheduleGrid.grid.rowCollapse({ rowIndx: scheduleIndex });
            this.scheduleOptions.dataModel.data[scheduleIndex] = schedule;
            this.scheduleGrid.grid.refreshRow({ rowIndx: scheduleIndex });
            if (schedule.dispatches.length > 0) {
                this.scheduleGrid.grid.rowExpand({ rowIndx: scheduleIndex });

                //expand the dispatch
                if (dispatchId > 0) {
                    let dispatchIndex: number = schedule.dispatches.findIndex(d => d.dispatchId == dispatchId);
                    if (dispatchIndex > -1) {
                        let rowData = this.scheduleGrid.grid.getRowData({ rowIndx: scheduleIndex });
                        let dispatchGrid = $(rowData.pq_detail.child).pqGrid('instance');
                        dispatchGrid.rowExpand({ rowIndx: dispatchIndex });
                    }
                }
            }
        }

        if (newSchedule) {
            this.scheduleOptions.dataModel.data.push(schedule);
            this.scheduleGrid.grid.refreshDataAndView();
        }

        this.onGridFilter();
    }

    refreshDispatch(dispatchId: number) {
        this._scheduleDataService.getDispatchItem(dispatchId).subscribe({
            next: data => {
                this.refreshGridDispatch(data);
            },
            error: err => this.errorMessage = err
        });
    }

    refreshGridDispatch(dispatch: DispatchItem) {
        let schedules: ScheduleItem[] = this.scheduleOptions.dataModel.data as ScheduleItem[];

        //I think this won't work for schedules created the other way from how they are being viewed - there will be no scheduleId
        //think could interate through all schedules and do find for dispatchId on each 
        let scheduleIndex: number = schedules.findIndex(s => s.scheduleId == dispatch.scheduleId);
        if (scheduleIndex > -1) {
            let dispatchIndex: number = schedules[scheduleIndex].dispatches.findIndex(d => d.dispatchId == dispatch.dispatchId);
            if (dispatchIndex > -1) {
                let rowData = this.scheduleGrid.grid.getRowData({ rowIndx: scheduleIndex });
                let dispatchGrid = $(rowData.pq_detail.child).pqGrid('instance');
                dispatchGrid.rowCollapse({ rowIndx: dispatchIndex });
                schedules[scheduleIndex].dispatches[dispatchIndex] = dispatch;
                dispatchGrid.refreshRow({ rowIndx: dispatchIndex });
                dispatchGrid.rowExpand({ rowIndx: dispatchIndex });
            }
        }
    }

    renameColumns() {
        let scheduleType = 'Destination';
        let dispatchType = 'Origin';
        let scheduleCodeType = 'Dest Code';
        let dispatchCodeType = 'Origin Code';
        if (this.scheduleParameters.locationType === LocationType.Origin) {
            scheduleType = 'Origin';
            dispatchType = 'Destination';
            scheduleCodeType = 'Origin Code';
            dispatchCodeType = 'Dest Code';
        }
        this.dispatchTypeLabel = dispatchType;
        for (let column of this.scheduleColumns) {
            if (column.title == dispatchType) {
                column.title = scheduleType;
            }
            if (column.title == dispatchCodeType) {
                column.title = scheduleCodeType;
            }
            if (column.title == 'Loc') {
                //only show loc column if loc group is selected
                if (this.scheduleParameters.locCode.startsWith('G')) {
                    column.hidden = false;
                }
                else {
                    column.hidden = true;
                }
            }
        }
        for (let column of this.dispatchColumns) {
            if (column.title == scheduleType) {
                column.title = dispatchType;
            }
        }
    }

    private formatDateWithLeadingZeros(dateStr: string): string {
        if (!dateStr) return '';

        const parts = dateStr.split('/');
        if (parts.length !== 3) return dateStr;

        const month = parts[0].padStart(2, '0');
        const day = parts[1].padStart(2, '0');
        const year = parts[2];

        return `${month}/${day}/${year}`;
    }

    refreshScheduleGrid(schedulesInfo: SchedulesInfo) {
        let dayColumns = schedulesInfo.dayColumns;

        const showDateRange = !['WeekCurrent', 'WeekPrevious', 'WeekNext', 'Today', 'Yesterday', 'Tomorrow',].includes(this.scheduleParameters.planPeriod);
        const dateRangeColumn = this.scheduleColumns.find(col => col.dataIndx === 'dateRange');
        if (dateRangeColumn) {
            dateRangeColumn.hidden = !showDateRange;
        }

        schedulesInfo.schedules.forEach(schedule => {
            schedule['dateRange'] = schedule.scheduleBeginDate && schedule.scheduleEndDate ? `${this.formatDateWithLeadingZeros(schedule.scheduleBeginDate)} - ${this.formatDateWithLeadingZeros(schedule.scheduleEndDate)}` : '';
        });

        if (dayColumns.length == 7) {
            for (let i = 0; i <= 6; i++) {
                let fieldName = 'planLoads' + i;
                let col = this.scheduleColumnsWithDays.find(x => x.dataIndx == fieldName);
                if (col !== undefined) {
                    col.title = dayColumns[i];
                }
            }

            const dateRangeColumnWithDays = this.scheduleColumnsWithDays.find(col => col.dataIndx === 'dateRange');
            if (dateRangeColumnWithDays) {
                dateRangeColumnWithDays.hidden = !showDateRange;
            }

            this.scheduleOptions.colModel = this.scheduleColumnsWithDays;
            this.showLoadsByDay = true;
        }
        else {
            this.scheduleOptions.colModel = this.scheduleColumns;
            this.showLoadsByDay = false;
        }
        this.scheduleOptions.dataModel.data = schedulesInfo.schedules;
        this.onGridFilter();
    }

    onGridFilter(): void {
        const allData = this.scheduleOptions.dataModel.data as any[];
        if (allData) {
            this.visibleSchedules.set(allData.filter(row => !row.pq_hidden) as ScheduleItem[]);
        }
    }

    clearFiltersClick() {
        this.clearFilters();
    }

    clearFilters(): void {
        this.scheduleParameters.truckerId = 0;
        this.scheduleParameters.locationName = '';
        this.scheduleParameters.locationCity = '';
        this.scheduleParameters.loadDate = '';
        this.scheduleParameters.deliveryDate = '';
        this.scheduleParameters.loadNumber = '';

        this.scheduleColumns.forEach(col => {
            if (col.filter?.crules?.[0]) {
                (col.filter.crules[0] as UserDefaultParameters).value = '';
            }
        });

        if (this.scheduleGrid?.grid?.reset) {
            this.scheduleGrid.grid.reset({ filter: true });
        }

        this.getDispatchFilterLists();
    }

    loadDefaultFilters(): void {
        const locCode = this.scheduleParameters.locCode;
        if (!locCode) {
            return;
        }

        this.clearFilters();

        const key = "ScheduleFilters"
        this._userDataService.getUserDefault(locCode, key).subscribe({
            next: (saved: any) => {
                if (!saved) {
                    this.getDispatchFilterLists();
                    return;
                }

                this.scheduleParameters = {
                    ...this.scheduleParameters,
                    truckerId: saved.formFilters?.truckerId ?? 0,
                    locationName: saved.formFilters?.locationName ?? "",
                    locationCity: saved.formFilters?.locationCity ?? "",
                    loadDate: saved.formFilters?.loadDate ?? "",
                    deliveryDate: saved.formFilters?.deliveryDate ?? "",
                    loadNumber: saved.formFilters?.loadNumber ?? ""
                };

                if (saved.filters?.length) {
                    saved.filters.forEach((savedFilter: UserDefaultParameters) => {
                        const col = this.scheduleColumns.find(c => c.dataIndx === savedFilter.dataIndx);
                        if (col?.filter?.crules?.[0]) {
                            (col.filter.crules[0] as UserDefaultParameters).value = savedFilter.value;
                        }
                    });
                }

                this.getDispatchFilterLists();
            },
            error: err => {
                this.errorMessage = err;
            }
        });
    }

    getDispatchFilterLists(): void {
        if (this.scheduleParameters.locCode.length === 0) {
            return;
        }

        this._scheduleDataService.getDispatchFilterLists(this.scheduleParameters).subscribe({
            next: data => {
                this.truckerList = data.truckers;
                this.locationList = data.locations;
                this.locationCityList = data.cities;
                this.scheduleDaysList = data.days;

                //clear filters values not in the filter lists
                this.clearInvalidDispatchFilters();

                if (!this.dontRefresh) {
                    this.refreshScheduleData();
                } else {
                    this.dontRefresh = false;
                }

            },
            error: err => this.errorMessage = err
        });
    }

    clearInvalidDispatchFilters(): void {  
        if (this.scheduleParameters.truckerId != 0) {
            if (!this.truckerList.some(item => item.id == this.scheduleParameters.truckerId)) {
                this.scheduleParameters.truckerId = 0;
            }
        }
        if (this.scheduleParameters.locationName.length > 0) {
            if (!this.locationList.some(item => item.value == this.scheduleParameters.locationName)) {
                this.scheduleParameters.locationName = '';
            }
        }
        if (this.scheduleParameters.locationCity.length > 0) {
            if (!this.locationCityList.some(item => item.value == this.scheduleParameters.locationCity)) {
                this.scheduleParameters.locationCity = '';
            }
        }
        if (this.scheduleParameters.loadDate.length > 0) {
            if (!this.scheduleDaysList.some(item => item.value == this.scheduleParameters.loadDate)) {
                this.scheduleParameters.loadDate = '';
            }
        }
        if (this.scheduleParameters.deliveryDate.length > 0) {
            if (!this.scheduleDaysList.some(item => item.value == this.scheduleParameters.deliveryDate)) {
                this.scheduleParameters.deliveryDate = '';
            }
        }
    }

    clearInvalidScheduleFilters(): void {
        const rows = (this.scheduleOptions?.dataModel?.data as any[]) ?? [];

        this.scheduleColumns.forEach(col => {
            const rule = col.filter?.crules?.[0] as any;
            const value = rule?.value;
            const cond = rule?.condition;

            if (value == null || value === '' || !col.dataIndx) {
                return;
            }

            const hasMatch = rows.some(r => {
                const cell = r[col.dataIndx];
                const cellStr = cell.toString().toLowerCase();

                if (Array.isArray(value)) {
                    return value.some(v => {
                        const valStr = v.toString().toLowerCase();
                        return cellStr.includes(valStr);
                    });
                }

                const valStr = value.toString().toLowerCase();

                if (cond === 'contain') {
                    return cellStr.includes(valStr);
                } else if (cond === 'begin') {
                    return cellStr.startsWith(valStr);
                } else if (cond === 'equal') {
                    return cellStr === valStr;
                }

                return false;
            });

            if (!hasMatch) {
                (col.filter!.crules![0] as any).value = Array.isArray(value) ? [] : '';
            }
        });
    }


    getEquipmentFieldsDefault(locCode: string): void {
        if (locCode.length === 0) {
            return;
        }
        this._listDataService.getLocDefaults(locCode, ['ShowEquipmentFields']).subscribe({
            next: data => {
                this.showEquipmentFields = data.find(c => c.key === 'ShowEquipmentFields')?.value === '1';
            },
            error: err => this.errorMessage = err
        });
    }

    refreshScheduleData(): void {
        if(this.scheduleParameters.locCode.length === 0) {
            return;
        }

        this.renameColumns();
        this.scheduleOptions.dataModel.data = [];

        this._scheduleDataService.getSchedules(this.scheduleParameters).subscribe({
            next: data => {
                this.refreshScheduleGrid(data);
                this.clearInvalidScheduleFilters();
                this.refreshDataComplete.emit(true);
            },
            error: err => this.errorMessage = err
        });

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['planningParameters'] || changes['refreshData']) {
            this.scheduleParameters.locCode = this.planningParameters.locCode;
            this.scheduleParameters.locationType = this.planningParameters.locationType;
            this.scheduleParameters.planPeriod = this.planningParameters.planPeriod;
            this.scheduleParameters.periodStartDate = this.planningParameters.periodStartDate;
            this.scheduleParameters.periodEndDate = this.planningParameters.periodEndDate;

            this.getEquipmentFieldsDefault(this.scheduleParameters.locCode);

            if (this.planningParameters.loadDefaultFilters && this.useDefaultFilters) {
                this.loadDefaultFilters();
                this.planningParameters.loadDefaultFilters = false;
            }
            else {
                this.getDispatchFilterLists();
            }
        }

        if (changes['refreshGrid']) {
            this.scheduleGrid?.grid?.refresh();
        }

        this.setGridHeight();
    }

    ngOnInit(): void {
        this._listDataService.getEquipmentTypes().subscribe({
            next: data => {
                this.equipmentTypes = data;
                this.equipmentTypeOptions.length = 0;
                this.equipmentTypeOptions.push('');
                data.forEach(e => this.equipmentTypeOptions.push(e.description));
            }
        });

        this._userSettingsService.useDefaultFilters$.subscribe(value => {
            if (value === false) {
                this._userDataService.clearAllUserDefaults('ScheduleFilters').subscribe();
            }

            this.useDefaultFilters = value;
        });

        //grid button click events
        let self = this;
        this.scheduleOptions.colModel[1].postRender = function (ui) {
            var scheduleId = ui.rowData.scheduleId;
            var scheduleLoads = ui.rowData.loads;
            var customerName = ui.rowData.customerName;
            var $cell = this.getCell(ui);
            var $editBtn = $cell.find('.edit-btn');
            var $deleteBtn = $cell.find('.delete-btn');
            var $dispatchBtn = $cell.find('.dispatch-btn');
            var $emailQuestionBtn = $cell.find('.question-email-btn');
            var locationInfo = ui.rowData.locationName;
            if (scheduleId > 0) {
                $editBtn.on('click', function () {
                    self.editSchedule(scheduleId);
                });
                if (scheduleLoads > 0) {
                    $dispatchBtn.on('click', function () {
                        self.newDispatch(scheduleId);
                    });
                }
                else {
                    $dispatchBtn.hide();
                }
                $deleteBtn.on('click', function () {
                    self.deleteSchedule(scheduleId, customerName, locationInfo);
                    return false;
                });
                $emailQuestionBtn.on('click', function () {
                    self.getEmailQuestionDetails(scheduleId, 0);
                    return false;
                });
            }
            else {
                $editBtn.hide();
                $deleteBtn.hide();
                $dispatchBtn.hide();
                $emailQuestionBtn.hide();
            }
        };

        this.setupDailyLoadsColumns();

        //grid change event to save updates made in grid
        this.scheduleOptions.change = function (evt, ui) {
            self.gridScheduleChange(evt, ui);
        }
    }

    dayLoadsColRender(ui, dayNumber) {
        const schedule = ui.rowData as ScheduleItem;
        if (schedule.scheduleId == 0) {
            return null;
        }

        const planLoads = schedule['planLoads' + dayNumber];
        const actualLoads = schedule.dailyLoads[dayNumber];
        let colProperties = { cls: 'grid-col-editable', attr: '' };

        if (planLoads > 0) {
            if (actualLoads == 0) {
                colProperties = { cls: 'loads-status-noloads', attr: 'title="no actual loads"' };
            }
            else if (actualLoads < planLoads) {
                colProperties = { cls: 'loads-status-toofew', attr: 'title="actual loads less than estimated loads"' };
            }
            else if (actualLoads > planLoads) {
                colProperties = { cls: 'loads-status-toomany', attr: 'title="actual loads exceeds estimated loads"' };
            }
            else {
                colProperties = { cls: 'loads-status-match', attr: 'title="actual loads equals estimated loads"' };
            }
        }
        return colProperties;
    }

    setupDailyLoadsColumns() {
        let self = this;

        this.scheduleColumnsWithDays = [...this.scheduleOptions.colModel];
        for (let i = 0; i <= 6; i++) {
            let fieldName = 'planLoads' + i;
            let dayLoadsCol = {
                title: "", width: 40, dataType: "integer",
                dataIndx: fieldName, align: "center", editable: true, sortable: false,
                clsHead: 'load-breakout-col-header',
                render: function (ui) { return self.dayLoadsColRender(ui, i); }
            };
            this.scheduleColumnsWithDays.push(dayLoadsCol);
        }
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.setGridHeight();
    }

    setGridHeight() {
        if (this.scheduleGrid) {
            let gridPosition = this.scheduleGrid.div.nativeElement.getBoundingClientRect();
            this.scheduleOptions.height = window.innerHeight - gridPosition.top - 35;
        }
    }

}
